import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen bg-[#050914] text-white flex items-center justify-center px-6"
      >
        <div className="max-w-md w-full bg-white/[0.02] border border-white/10 rounded-2xl p-8 text-center">
          <div className="w-14 h-14 rounded-2xl bg-red-400/10 border border-red-400/30 flex items-center justify-center mx-auto mb-5">
            <AlertTriangle className="w-7 h-7 text-red-400" strokeWidth={1.5} />
          </div>
          <h1 className="text-xl font-medium text-white mb-2">Terjadi kesalahan</h1>
          <p className="text-sm text-white/60 mb-6">
            Maaf, ada gangguan saat menampilkan halaman ini. Silakan muat ulang untuk melanjutkan.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={this.handleReload}
            className="inline-flex items-center gap-2 bg-cyan-400 text-[#050914] font-medium px-6 py-2.5 rounded-lg transition-colors hover:bg-cyan-300"
          >
            <RotateCcw className="w-4 h-4" strokeWidth={2} /> Muat Ulang
          </button>
        </div>
      </div>
    );
  }
}
